import { useAuthStore } from '@core/stores/auth'

// Navigation guard for authentication. Pages opt in with definePageMeta({ requiresAuth: true }).
export default defineNuxtRouteMiddleware((to) => {
    const authStore = useAuthStore()

    if (to.meta.requiresAuth && !authStore.isAuthenticated) {
        return navigateTo({ name: 'Login', query: { redirect: to.fullPath } })
    }

    if (to.name === 'Login' && authStore.isAuthenticated) {
        return navigateTo({ name: 'Home' })
    }
})
